import { SystemFuncArgs } from '$legacyecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreSheetLayer from 'editor/components/CarnivoreSheetLayer';
import TileLayers from 'editor/components/TileLayers';
import Zooming from 'editor/components/Zooming';
import { Components } from '../components';

export const renderTileZoomComponents = [
  CarnivoreDoc,
  CarnivoreSheetLayer,
  TileLayers,
  Zooming,
];

const getZoomLevel = (scale: number, zoomLevelCount: number): number => {
  const zoomBreak = 1 / zoomLevelCount;
  const zoomLevel = Math.min(Math.ceil(scale / zoomBreak), zoomLevelCount);
  return zoomLevel;
};

export function renderTileZoom(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const tileLayersComponent = components.get(TileLayers);
  const zoomComp = components.get(Zooming);
  const sheeetLayerComp = components.get(CarnivoreSheetLayer);

  const { doc } = components.get(CarnivoreDoc);
  const { zoomCanvases, currentZoomLevel } = tileLayersComponent;

  const canvasScale = doc.transform[0];
  const canvasZoomLevel = getZoomLevel(
    canvasScale,
    tileLayersComponent.zoomCanvases.size
  );

  const hasFinishedZooming = !zoomComp.isZooming();

  if (currentZoomLevel !== canvasZoomLevel && hasFinishedZooming) {
    tileLayersComponent.currentZoomLevel = canvasZoomLevel;

    const zoomCanvas = zoomCanvases.get(canvasZoomLevel);
    if (!sheeetLayerComp) return;

    const { sheetLayer } = sheeetLayerComp;
    if (zoomCanvas) {
      sheetLayer.fillBuffer(zoomCanvas);
      sheetLayer.markAsDirty();
    }
  }
}
